import { useNavigate } from 'react-router-dom';

export default function Hero() {
  const navigate = useNavigate();

  const handleBooking = () => {
    navigate('/booking');
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/27ec64517b57f2b63ca6965b277ac2c9.jpg"
          alt="Happy pets playing"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-[#9B4C9A]/40 via-[#C77DFF]/30 to-[#FF9BC8]/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-6 max-w-5xl mx-auto w-full">

        {/* Subheading */}
        <p className="text-2xl lg:text-3xl text-white mb-12 leading-relaxed max-w-3xl mx-auto animate-fade-in-up animate-delay-200" style={{ textShadow: '0 2px 20px rgba(0,0,0,0.3)' }}>
          Professional grooming, daycare, and boarding services
          <br />
          for your furry family members
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-6 animate-fade-in-up animate-delay-300">
          <button
            onClick={handleBooking}
            className="bg-gradient-to-r from-[#9B4C9A] to-[#FF9BC8] text-white px-10 py-5 rounded-full text-xl font-bold hover:shadow-2xl hover:scale-105 transition-all inline-flex items-center gap-3 whitespace-nowrap cursor-pointer"
          >
            Book Appointment
            <i className="ri-calendar-check-line text-2xl"></i>
          </button>

          <button className="bg-white/95 backdrop-blur-sm text-[#9B4C9A] px-10 py-5 rounded-full text-xl font-bold hover:bg-white hover:scale-105 transition-all inline-flex items-center gap-3 whitespace-nowrap cursor-pointer">
            Learn More
            <i className="ri-arrow-right-line text-2xl"></i>
          </button>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-3 gap-8 mt-20 max-w-3xl mx-auto">
          <div className="bg-white/95 backdrop-blur-sm rounded-2xl p-6 shadow-xl animate-scale-in animate-delay-400 hover:scale-105 transition-transform">
            <div className="text-4xl font-bold bg-gradient-to-r from-[#9B4C9A] to-[#FF9BC8] bg-clip-text text-transparent mb-2">
              10K+
            </div>
            <div className="text-gray-600 font-medium">Happy Pets</div>
          </div>
          <div className="bg-white/95 backdrop-blur-sm rounded-2xl p-6 shadow-xl animate-scale-in animate-delay-500 hover:scale-105 transition-transform">
            <div className="text-4xl font-bold bg-gradient-to-r from-[#9B4C9A] to-[#FF9BC8] bg-clip-text text-transparent mb-2">
              24+
            </div>
            <div className="text-gray-600 font-medium">Years Experience</div>
          </div>
          <div className="bg-white/95 backdrop-blur-sm rounded-2xl p-6 shadow-xl animate-scale-in animate-delay-600 hover:scale-105 transition-transform">
            <div className="text-4xl font-bold bg-gradient-to-r from-[#9B4C9A] to-[#FF9BC8] bg-clip-text text-transparent mb-2">
              5★
            </div>
            <div className="text-gray-600 font-medium">Rating</div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-4xl text-white" style={{ textShadow: '0 2px 10px rgba(0,0,0,0.3)' }}></i>
      </div>
    </section>
  );
}
